export default {
  tooltips: {
    metrics: {
      online: 'Solicitar métricas del servidor cada 15 segundos'
    }
  }
}
